module.exports = __webpack_public_path__ + "static/intro-08959e499bb9ba5b78d861816fa1437f.svg";